// extracted by mini-css-extract-plugin
export default {"sidebarStyles":"styles-module__sidebarStyles__src-labstep-web-core-SideMenu-_Vvq9T"};